export default {
   apiBaseUrl: 'https://api.collectgo.eu/',

   msalConfig: {
      auth: {
        clientId: 'fd1bfe64-ada5-4767-abb3-a6f22b6d12a7',
        redirectUri: 'https://portal.collectgo.eu',
        authority: 'https://login.microsoftonline.com/common',

        postLogoutRedirectUri: 'https://portal.collectgo.eu'
      },
   },
}
